<template>
    <div id="app">
        <router-view/>
    </div>
</template>
<script>
  export default {

    data() {
      return {}
    },
    created() {

    },
    mounted() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
  }
</script>

<style lang="less">
    @import "./assets/css/base";

</style>
